import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from '@/firebase/init'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    go: route => {
      if (router.history.current.name != route) {
        router.push({ name: route }).catch(() => {})
      }
    },
  }
})

Vue.use(vuetify, {
  iconfont: 'mdi'
})

let app = null

firebase.auth().onAuthStateChanged(() => {
  if(!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})